module.exports = __webpack_public_path__ + "img/money-group.a55c84a0.svg";